import { exactlyOne, zip, map } from "../../../fable_modules/fable-library-js.4.19.3/Seq.js";
import { setCenterlinePlanes, createCenterlinePlaneUpdater } from "../../../../../src/RAWMap.Client/Visualization/CenterlineMeasurement/CenterlinePlaneHooks.js";
import { Helpers_addOrUpdateMeasurements, CenterlineMeasurementViewModel_toCenterlinePlanes, Helpers_recomputeViewmodel, updatePlaneIndex, ArrayNames_fieldDataArrayNames, ArrayNames_pointDataArrayNames } from "../CenterlineMeasurementCoreTypes.js";
import { equals, comparePrimitives, defaultOf } from "../../../fable_modules/fable-library-js.4.19.3/Util.js";
import { filter, change, FSharpMap__get_Item, add, tryFind, ofSeq, map as map_1, values, empty } from "../../../fable_modules/fable-library-js.4.19.3/Map.js";
import { OutboundMsg, MeasurementData, getCenterlineBounds as getCenterlineBounds_1, DataEntryState, Updater, LocalMsg, ModelCenterlineMeasurement, Mode as Mode_4, CenterlineData } from "./CenterlineMeasurementTypes.js";
import { Cmd_batch, Cmd_ofEffect, Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { StentMeasurement__get_name, StentMeasurement__get_centerlineMeasurement, StentMeasurement_update, RelatedStentMeasurement, StentMeasurement__setName_Z721C83C5 } from "./SharedTypes.js";
import { newGuid } from "../../../fable_modules/fable-library-js.4.19.3/Guid.js";
import { Bindings_PlaneIdentifier_Id_Z3EBB1C36, Bindings_PlaneIdentifier } from "../../../RAWMap.Models/View/CenterlineMeasurement.js";
import { map as map_2, defaultArg, some } from "../../../fable_modules/fable-library-js.4.19.3/Option.js";
import { toArray, singleton } from "../../../fable_modules/fable-library-js.4.19.3/List.js";
import { equalsWith } from "../../../fable_modules/fable-library-js.4.19.3/Array.js";
import { Toast_errorToast } from "../../../Common/General.js";
import { update as update_1 } from "../../../Common/InboundOutbound.js";

export function initializeMeasurementUpdater(meshes, pointDataArrayNames, fieldDataArrayNames, mkUpdateMsgs, mkInitializedMsg, dispatch) {
    dispatch(mkInitializedMsg(map((mkUpdateMsg) => createCenterlinePlaneUpdater(meshes, pointDataArrayNames, fieldDataArrayNames, (arg) => {
        dispatch(mkUpdateMsg(arg));
    }), mkUpdateMsgs)));
}

export function init(meshes) {
    return [new ModelCenterlineMeasurement(new CenterlineData(meshes, ArrayNames_pointDataArrayNames, ArrayNames_fieldDataArrayNames, defaultOf(), empty({
        Compare: comparePrimitives,
    })), new Mode_4(0, []), undefined), Cmd_none()];
}

export function updateInbound(_token, msg, model) {
    let arg, bind$0040;
    switch (msg.tag) {
        case 1: {
            const measurementData = msg.fields[0];
            let initializeRelatedUpdater;
            const matchValue = model.CenterlineData.MaybeMeshes;
            initializeRelatedUpdater = ((matchValue == null) ? Cmd_none() : Cmd_ofEffect((arg = [matchValue, model.CenterlineData.PointDataArrayNames, model.CenterlineData.FieldDataArrayNames, values(map_1((rmName, rm) => ((m) => (new LocalMsg(7, [rmName, rm, m]))), measurementData.RelatedMeasurements)), (updaters) => (new LocalMsg(2, [new Updater(1, [zip(updaters, values(map_1((k, v) => (new RelatedStentMeasurement(StentMeasurement__setName_Z721C83C5(v.Measurement, k), v.UpdateIndex)), measurementData.RelatedMeasurements)))])]))], (dispatch_1) => {
                initializeMeasurementUpdater(arg[0], arg[1], arg[2], arg[3], arg[4], dispatch_1);
            })));
            const relatedCallbackIds = map_1((_arg, _arg_1) => newGuid(), measurementData.RelatedMeasurements);
            return [new ModelCenterlineMeasurement(model.CenterlineData, new Mode_4(1, [new DataEntryState(measurementData, [], empty({
                Compare: comparePrimitives,
            }), [], empty({
                Compare: comparePrimitives,
            }), newGuid(), relatedCallbackIds)]), new Bindings_PlaneIdentifier(0, [])), initializeRelatedUpdater, Cmd_none()];
        }
        case 3:
            return [new ModelCenterlineMeasurement(model.CenterlineData, model.Mode, msg.fields[0]), Cmd_none(), Cmd_none()];
        case 4:
            return [new ModelCenterlineMeasurement(model.CenterlineData, new Mode_4(0, []), undefined), Cmd_none(), Cmd_none()];
        case 2: {
            const planeIdentifier_1 = msg.fields[0];
            const index = msg.fields[1] | 0;
            const matchValue_1 = model.Mode;
            let matchResult, state_1;
            if (matchValue_1.tag === 1) {
                if (index >= 0) {
                    matchResult = 0;
                    state_1 = matchValue_1.fields[0];
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    const updatedValue = StentMeasurement_update(state_1.measurementData.ActiveMeasurement, updatePlaneIndex(getCenterlineBounds_1(model.CenterlineData.CenterlinePlaneUpdater, state_1.measurementData.centerline), planeIdentifier_1, index, StentMeasurement__get_centerlineMeasurement(state_1.measurementData.ActiveMeasurement)));
                    let previousIndex;
                    const matchValue_2 = StentMeasurement__get_centerlineMeasurement(state_1.measurementData.ActiveMeasurement);
                    switch (matchValue_2.tag) {
                        case 0: {
                            const vm = matchValue_2.fields[0][0];
                            previousIndex = ((planeIdentifier_1.tag === 0) ? vm.firstIndex : vm.secondIndex);
                            break;
                        }
                        case 2: {
                            previousIndex = matchValue_2.fields[0][0].index;
                            break;
                        }
                        default: {
                            console.error(some("Unexpected centerline measurement type"));
                            previousIndex = index;
                        }
                    }
                    const updatedData = new MeasurementData(state_1.measurementData.centerline, updatedValue, map_1((_name, rm_1) => {
                        let relatedMeasurement, matchValue_3, vm_2, matchValue_5;
                        return new RelatedStentMeasurement(rm_1.UpdateIndex((relatedMeasurement = rm_1.Measurement, (matchValue_3 = StentMeasurement__get_centerlineMeasurement(updatedValue), (matchValue_3.tag === 0) ? ((vm_2 = matchValue_3.fields[0][0], (vm_2.secondIndex < vm_2.firstIndex) ? ((StentMeasurement__get_centerlineMeasurement(relatedMeasurement).tag === 0) ? ((planeIdentifier_1.tag === 0) ? (new Bindings_PlaneIdentifier(1, [])) : (new Bindings_PlaneIdentifier(0, []))) : planeIdentifier_1) : ((vm_2.secondIndex === vm_2.firstIndex) ? ((matchValue_5 = StentMeasurement__get_centerlineMeasurement(relatedMeasurement), (planeIdentifier_1.tag === 1) ? ((matchValue_5.tag === 0) ? ((previousIndex < index) ? (new Bindings_PlaneIdentifier(0, [])) : planeIdentifier_1) : planeIdentifier_1) : planeIdentifier_1)) : planeIdentifier_1))) : planeIdentifier_1)), index, rm_1.Measurement), rm_1.UpdateIndex);
                    }, state_1.measurementData.RelatedMeasurements));
                    const relatedCallbackIds_1 = map_1((_arg_2, _arg_3) => newGuid(), state_1.relatedCallbackIds);
                    return [new ModelCenterlineMeasurement(model.CenterlineData, new Mode_4(1, [new DataEntryState(updatedData, new Array(0), empty({
                        Compare: comparePrimitives,
                    }), state_1.planePipelines, state_1.relatedPlanePipelines, newGuid(), relatedCallbackIds_1)]), planeIdentifier_1), Cmd_batch(singleton(singleton((dispatch_2) => {
                        dispatch_2(new LocalMsg(3, []));
                    }))), Cmd_none()];
                }
                default:
                    return [model, Cmd_none(), Cmd_none()];
            }
        }
        default:
            return [new ModelCenterlineMeasurement((bind$0040 = model.CenterlineData, new CenterlineData(msg.fields[0], bind$0040.PointDataArrayNames, bind$0040.FieldDataArrayNames, bind$0040.CenterlinePlaneUpdater, bind$0040.RelatedCenterlinePlaneUpdaters)), model.Mode, model.MaybeSelectedPlaneIdentifier), singleton((dispatch) => {
                dispatch(new LocalMsg(1, []));
            }), Cmd_none()];
    }
}

export function updateLocal(_token, msg, model) {
    let arg_2, bind$0040_1, bind$0040, bind$0040_2, bind$0040_3, msg_9;
    const recomputeViewmodel = (updatedMeasurements, centerline, measurement, callbackId, planePipelines) => {
        const updater = model.CenterlineData.CenterlinePlaneUpdater;
        return Helpers_recomputeViewmodel(updatedMeasurements, StentMeasurement__get_centerlineMeasurement(measurement), callbackId, centerline, updater, (cvm) => StentMeasurement_update(measurement, cvm), () => getCenterlineBounds_1(updater, centerline), measurement, planePipelines);
    };
    switch (msg.tag) {
        case 1: {
            const matchValue_2 = model.CenterlineData.MaybeMeshes;
            if (matchValue_2 == null) {
                console.error(some("Expected a value for meshes but was None"));
                return [model, Cmd_none(), Cmd_none()];
            }
            else {
                return [model, Cmd_ofEffect((arg_2 = [matchValue_2, model.CenterlineData.PointDataArrayNames, model.CenterlineData.FieldDataArrayNames, singleton((Item) => (new LocalMsg(4, [Item]))), (arg_1) => (new LocalMsg(2, [new Updater(0, [exactlyOne(arg_1)])]))], (dispatch) => {
                    initializeMeasurementUpdater(arg_2[0], arg_2[1], arg_2[2], arg_2[3], arg_2[4], dispatch);
                })), Cmd_none()];
            }
        }
        case 2:
            if (msg.fields[0].tag === 1) {
                const matchValue_3 = model.Mode;
                if (matchValue_3.tag === 1) {
                    const state = matchValue_3.fields[0];
                    const relatedPipelines = ofSeq(map((tupledArg) => {
                        const relatedMeasurement = tupledArg[1];
                        let pipelines;
                        const cm = StentMeasurement__get_centerlineMeasurement(relatedMeasurement.Measurement);
                        pipelines = setCenterlinePlanes(model.CenterlineData.CenterlinePlaneUpdater, toArray(CenterlineMeasurementViewModel_toCenterlinePlanes(newGuid(), state.measurementData.centerline, cm)));
                        return [StentMeasurement__get_name(relatedMeasurement.Measurement), pipelines];
                    }, msg.fields[0].fields[0]), {
                        Compare: comparePrimitives,
                    });
                    return [new ModelCenterlineMeasurement((bind$0040_1 = model.CenterlineData, new CenterlineData(bind$0040_1.MaybeMeshes, bind$0040_1.PointDataArrayNames, bind$0040_1.FieldDataArrayNames, bind$0040_1.CenterlinePlaneUpdater, ofSeq(map((tupledArg_1) => [StentMeasurement__get_name(tupledArg_1[1].Measurement), tupledArg_1[0]], msg.fields[0].fields[0]), {
                        Compare: comparePrimitives,
                    }))), new Mode_4(1, [new DataEntryState(state.measurementData, state.centerlinePointMeasurements, state.relatedCenterlinePointMeasurements, state.planePipelines, relatedPipelines, state.expectedCallbackId, state.relatedCallbackIds)]), model.MaybeSelectedPlaneIdentifier), singleton((dispatch_2) => {
                        dispatch_2(new LocalMsg(3, []));
                    }), Cmd_none()];
                }
                else {
                    return [model, Cmd_none(), Cmd_none()];
                }
            }
            else {
                return [new ModelCenterlineMeasurement((bind$0040 = model.CenterlineData, new CenterlineData(bind$0040.MaybeMeshes, bind$0040.PointDataArrayNames, bind$0040.FieldDataArrayNames, msg.fields[0].fields[0], bind$0040.RelatedCenterlinePlaneUpdaters)), model.Mode, model.MaybeSelectedPlaneIdentifier), Cmd_none(), singleton((dispatch_1) => {
                    dispatch_1(new OutboundMsg(0, []));
                })];
            }
        case 4: {
            const matchValue_4 = model.Mode;
            let matchResult, state_2;
            if (matchValue_4.tag === 1) {
                if (msg.fields[0].callbackIdentifier === matchValue_4.fields[0].expectedCallbackId) {
                    matchResult = 0;
                    state_2 = matchValue_4.fields[0];
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    const updatedMeasurements_1 = Helpers_addOrUpdateMeasurements(state_2.centerlinePointMeasurements, msg.fields[0]);
                    const patternInput_1 = recomputeViewmodel(updatedMeasurements_1, state_2.measurementData.centerline, state_2.measurementData.ActiveMeasurement, state_2.expectedCallbackId, state_2.planePipelines);
                    return [new ModelCenterlineMeasurement(model.CenterlineData, new Mode_4(1, [new DataEntryState((bind$0040_2 = state_2.measurementData, new MeasurementData(bind$0040_2.centerline, patternInput_1[0], bind$0040_2.RelatedMeasurements)), updatedMeasurements_1, state_2.relatedCenterlinePointMeasurements, patternInput_1[1], state_2.relatedPlanePipelines, state_2.expectedCallbackId, state_2.relatedCallbackIds)]), model.MaybeSelectedPlaneIdentifier), singleton((dispatch_3) => {
                        dispatch_3(new LocalMsg(5, []));
                    }), Cmd_none()];
                }
                default:
                    return [model, Cmd_none(), Cmd_none()];
            }
        }
        case 7: {
            const matchValue_5 = model.Mode;
            let matchResult_1, state_4;
            if (matchValue_5.tag === 1) {
                if (msg.fields[2].callbackIdentifier === FSharpMap__get_Item(matchValue_5.fields[0].relatedCallbackIds, msg.fields[0])) {
                    matchResult_1 = 0;
                    state_4 = matchValue_5.fields[0];
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0: {
                    const updatedPointMeasurements = Helpers_addOrUpdateMeasurements(defaultArg(tryFind(msg.fields[0], state_4.relatedCenterlinePointMeasurements), []), msg.fields[2]);
                    const UpdatedCpms = add(msg.fields[0], updatedPointMeasurements, state_4.relatedCenterlinePointMeasurements);
                    const patternInput_2 = recomputeViewmodel(updatedPointMeasurements, state_4.measurementData.centerline, msg.fields[1].Measurement, FSharpMap__get_Item(state_4.relatedCallbackIds, msg.fields[0]), FSharpMap__get_Item(state_4.relatedPlanePipelines, msg.fields[0]));
                    const updatedPipelines_1 = patternInput_2[1];
                    const updatedMeasurement_1 = patternInput_2[0];
                    return [new ModelCenterlineMeasurement(model.CenterlineData, new Mode_4(1, [new DataEntryState((bind$0040_3 = state_4.measurementData, new MeasurementData(bind$0040_3.centerline, bind$0040_3.ActiveMeasurement, change(msg.fields[0], (option_1) => map_2((rm) => (new RelatedStentMeasurement(updatedMeasurement_1, rm.UpdateIndex)), option_1), state_4.measurementData.RelatedMeasurements))), state_4.centerlinePointMeasurements, UpdatedCpms, state_4.planePipelines, add(msg.fields[0], updatedPipelines_1, state_4.relatedPlanePipelines), state_4.expectedCallbackId, state_4.relatedCallbackIds)]), model.MaybeSelectedPlaneIdentifier), !equalsWith(equals, updatedPipelines_1, FSharpMap__get_Item(state_4.relatedPlanePipelines, msg.fields[0])) ? singleton((dispatch_4) => {
                        dispatch_4(new LocalMsg(6, [updatedMeasurement_1]));
                    }) : Cmd_none(), Cmd_none()];
                }
                default:
                    return [model, Cmd_none(), Cmd_none()];
            }
        }
        case 3: {
            const matchValue_6 = model.Mode;
            if (matchValue_6.tag === 1) {
                const state_5 = matchValue_6.fields[0];
                return [new ModelCenterlineMeasurement(model.CenterlineData, new Mode_4(1, [new DataEntryState(state_5.measurementData, state_5.centerlinePointMeasurements, state_5.relatedCenterlinePointMeasurements, setCenterlinePlanes(model.CenterlineData.CenterlinePlaneUpdater, toArray(CenterlineMeasurementViewModel_toCenterlinePlanes(state_5.expectedCallbackId, state_5.measurementData.centerline, StentMeasurement__get_centerlineMeasurement(state_5.measurementData.ActiveMeasurement)))), map_1((name_1, rm_1) => {
                    let vm_2;
                    const planes_2 = toArray((vm_2 = StentMeasurement__get_centerlineMeasurement(rm_1.Measurement), CenterlineMeasurementViewModel_toCenterlinePlanes(FSharpMap__get_Item(state_5.relatedCallbackIds, name_1), state_5.measurementData.centerline, vm_2)));
                    const updatedPipelines_3 = setCenterlinePlanes(FSharpMap__get_Item(model.CenterlineData.RelatedCenterlinePlaneUpdaters, name_1), planes_2);
                    updatedPipelines_3.forEach((p) => {
                        p.centerlinePlaneSource.planeIndexFilter.getOutputData(0);
                    });
                    return updatedPipelines_3;
                }, filter((name, _rm) => {
                    const matchValue_8 = model.MaybeSelectedPlaneIdentifier;
                    let matchResult_2;
                    if (state_5.measurementData.ActiveMeasurement.tag === 0) {
                        matchResult_2 = 0;
                    }
                    else if (matchValue_8 != null) {
                        matchResult_2 = 1;
                    }
                    else {
                        matchResult_2 = 0;
                    }
                    switch (matchResult_2) {
                        case 0:
                            return true;
                        default: {
                            const planeId = matchValue_8;
                            return name.indexOf(Bindings_PlaneIdentifier_Id_Z3EBB1C36(planeId)) === 0;
                        }
                    }
                }, state_5.measurementData.RelatedMeasurements)), state_5.expectedCallbackId, state_5.relatedCallbackIds)]), model.MaybeSelectedPlaneIdentifier), Cmd_none(), Cmd_none()];
            }
            else {
                return [model, Cmd_none(), Cmd_none()];
            }
        }
        case 5: {
            const matchValue_10 = model.Mode;
            if (matchValue_10.tag === 1) {
                return [model, Cmd_none(), (msg_9 = (new OutboundMsg(1, [StentMeasurement__get_centerlineMeasurement(matchValue_10.fields[0].measurementData.ActiveMeasurement)])), singleton((dispatch_5) => {
                    dispatch_5(msg_9);
                }))];
            }
            else {
                return [model, Cmd_none(), Cmd_none()];
            }
        }
        case 6:
            return [model, Cmd_none(), singleton((dispatch_6) => {
                dispatch_6(new OutboundMsg(2, [msg.fields[0]]));
            })];
        default: {
            console.error(some(`CenterlineMeasurement exception: ${msg.fields[0]}`));
            return [model, Toast_errorToast("An error has occured"), Cmd_none()];
        }
    }
}

export function update(token, msg, model) {
    return update_1(updateLocal, updateInbound, token, msg, model);
}

